import { makeStyles } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import DashboardLayout, {DashboardPage} from '../layout'
import {Select} from 'antd'
import {PlusOutlined} from '@ant-design/icons'
import ToolsTableView from './table_view'
import { useData } from '../../../data'
import {trackPromise, usePromiseTracker} from 'react-promise-tracker'
import { useRouter } from '../../../routes'
import EditTool from '../admin/tools/edit'


const {Option} = Select

const useStyles = makeStyles(theme => ({
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.up('lg')]: {
            width: '30%'
        }
    },
    title: {
        fontSize: 16,
        fontWeight: 'normal',
        fontStyle: 'normal',
        marginBottom: 0
    },
    content: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
}))

/**
 * Tools dashboard view page
 */
const ToolsPage = (props) => {
    const router = useRouter()
    const [currentPage, setCurrentPage] = useState(router.query?.page ? parseInt(router.query?.page) : 1)
    const [limit, setLimit] = useState(router.query?.limit ? parseInt(router.query?.limit) : 10)
    const [count, setCount] = useState(0)
    const [category, setCategory] = useState(router.query?.filterCategory)
    
    const [showToolDrawer, setToolShowDrawer] = useState(false)
    const [ordering, setOrdering] = useState(router.query?.ordering ?? '')
    const [editToolData, setEditToolData] = useState(null)
    const [isSuperUser, setIsSuperUser] = useState(false);

    const [tools, setTools] = useState([])

    const classes = useStyles()
    const data = useData()
    const auth = data.auth()

    // get the tools API
    const toolsApi = data.tools()

    /**
     * Load all tools
     */
    const loadTools = () => {
        const offset = (currentPage - 1) * limit;

        // get a list of tools from the API and track loading time
        trackPromise(
            toolsApi.getAllTools(limit, offset, ordering, category)
                .then(({tools, count}) => {
                    setTools(tools)
                    setCount(count)

                    router.replace({
                        search: `?page=${currentPage}&limit=${limit}&ordering=${ordering}`
                    })
                })
                .catch(error => {
                    const {message} = error

                    console.log(message)
                })
        )
    }

    // load the current user
    const loadUser = () => {
        trackPromise(
            auth.getCurrentUser()
                .then((val) => setIsSuperUser(val.is_superuser))
                .catch(console.log), 'get_user'
        )
    }


    /**
     * Retrieve tools from the server
     */

    useEffect(() => {
        loadTools()
        loadUser()
        // eslint-disable-next-line
    }, [limit, currentPage, ordering, category, isSuperUser])

    
    /**
     * 
     * Go to new tool page
    */
     const goToNewTool = () => {
      
        return router.push('/dashboard/tool/new')
    }
    

    /**
     * Change the tool category
     *
     * @param {string} category - selected category
     */
    const selectFilterCategory = category => {
      setCategory(category);
    }

    // show tool details
    const showDetails = (tool) => {
        const {id} = tool
        router.push(`/dashboard/tool?id=${id}`)
    }

    //show sidebar to edit tool
    const editTool = (tool) => {
        const {id} = tool
        router.push(`/dashboard/tool/edit?id=${id}`, tool)
    }

    const closeToolDrawer = (tool) => {
        setToolShowDrawer(false)
        setEditToolData(null)
        loadTools()
    }

    // data loading
    const {promiseInProgress} = usePromiseTracker()


    return (
        <DashboardLayout
            selected="tools"
        >
            <DashboardPage
                title="Tools"
                ctaIcon={<PlusOutlined />}
                buttonText="Create a Tool"
                disabled={!isSuperUser}
                onCtaClick={() => goToNewTool()}
            >
                <>
                    <div className={classes.topBar}>
                        <p className={classes.title}>Leading Sourcing Tools</p>
                        <Select onChange={selectFilterCategory} defaultValue="All Tools">
                            <Option value={null}>All Tools</Option>
                            <Option value="job">Job</Option>
                            <Option value="contact">Lead Profile</Option>
                            <Option value="email">Email</Option>
                        </Select>
                    </div>

                    <div className={classes.content}>
                        <ToolsTableView
                            tools={tools}
                            onSelectTool={showDetails}
                            loading={promiseInProgress}
                            setOrdering={setOrdering}
                            count={count}
                            updateLimit={setLimit}
                            updatePage={setCurrentPage}
                            page={currentPage}
                            limit={limit}
                            editTool={editTool}
                        />
                    </div>
                </>

               

                <EditTool
                    visible={showToolDrawer}
                    close={closeToolDrawer}
                    tool={editToolData}
                />
            </DashboardPage>
        </DashboardLayout>
    )
}

export default ToolsPage
